import ReactGA from "react-ga";

export const AddGoogleAnalyticsPageView = ({
    isGoogleAnalyticsInitialized,
  }) => {
      
    if (isGoogleAnalyticsInitialized) {
      
      const path = window.location.pathname;
      ReactGA.set({ path });
      ReactGA.pageview(path);
    }
  };